import { Injectable } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { GlobalConstants } from './global-constants';

@Injectable({
  providedIn: 'root'
})
export class CoordinatorRedirectService {

  constructor(private router: Router) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        let rawType = localStorage.getItem('externalUser')
        if (rawType) {
          let role = JSON.parse(rawType);
          if (role.status != true && event.url.includes('coordinator-view')) {
            window.location.href = window.location.origin + "/home"
          }
        }
      }
    });
  }
}
